import { MARKING_STATES } from "../../../utils/marking.js";
import { OPERATIONS } from "../../../constants/operations.js";

export const INACTIVE = "inactive";
export const DISABLED = "disabled";

export const WORKING_VALUES = [
  MARKING_STATES.STARTING,
  MARKING_STATES.STOPPING
];

export const ICON_MAP = {
  [OPERATIONS.START]: "play",
  [OPERATIONS.STOP]: "stop",
  [MARKING_STATES.STARTING]: "sync alternate",
  [MARKING_STATES.STOPPING]: "sync alternate",
  inactive: "times",
  disabled: "times"
};

export const POWER_ICON_MAP = {
  [OPERATIONS.START]: { icon: "power off", color: "grey" },
  [OPERATIONS.STOP]: { icon: "power off", color: "green" },
  [MARKING_STATES.STARTING]: { icon: "sync alternate", color: "grey" },
  [MARKING_STATES.STOPPING]: { icon: "sync alternate", color: "grey" },
  inactive: { icon: "times", color: "grey" },
  disabled: { icon: "times", color: "grey" }
};
